import Vue from 'vue'
import Router from 'vue-router'
import {
  Common,
  storage
} from '@/utils/common'
import browser from '@/utils/browser'
import wxShare from '@/utils/wxShare'

Vue.use(Router)

const router = new Router({
  routes: [{
      path: '/',
      component: resolve => require(['@/components/register'], resolve),
      meta: {
        title: '邀请监督'
      }
    },
    {
      path: '/register',
      name: 'register',
      component: resolve => require(['@/components/register'], resolve),
      meta: {
        title: '邀请监督'
      }
    },
    {
      path: '/registerAgreement',
      name: 'registerAgreement',
      component: resolve => require(['@/components/registerAgreement'], resolve),
      meta: {
        title: '用户协议'
      }
    },
    {
      path: '/downLoad',
      name: 'downLoad',
      component: resolve => require(['@/components/downLoad'], resolve),
      meta: {
        title: '下载'
      }
    },
    {
      path: '/downLoadSpring',
      name: 'downLoadSpring',
      component: resolve => require(['@/components/downLoadSpring'], resolve),
      meta: {
        title: '下载'
      }
    },
    {
      path: '/useTip',
      name: 'useTip',
      component: resolve => require(['@/components/useTip'], resolve),
      meta: {
        title: '用户提示'
      }
    },
    {
      path: '/goldCoinMall',
      name: 'goldCoinMall',
      component: resolve => require(['@/view/coinMall/goldCoinMall'], resolve),
      meta: {
        title: '金币兑换'
      }
    },
    {
      path: '/lotteryRule',
      name: 'lotteryRule',
      component: resolve => require(['@/view/coinMall/lotteryRule'], resolve),
      meta: {
        title: '抽奖说明'
      }
    },
    {
      path: '/integralDescription',
      name: 'integralDescription',
      component: resolve => require(['@/view/coinMall/integralDescription'], resolve),
      meta: {
        title: '兑换说明'
      }
    },
    {
      path: '/redeemDetail',
      name: 'redeemDetail',
      component: resolve => require(['@/view/coinMall/redeemDetail'], resolve),
      meta: {
        title: '立即兑换'
      }
    },
    {
      path: '/customerService',
      name: 'customerService',
      component: resolve => require(['@/view/customerService'], resolve),
      meta: {
        title: '帮助中心'
      }
    },
    {
      path: '/chatOnLine',
      name: 'chatOnLine',
      component: resolve => require(['@/view/chatOnLine'], resolve),
      meta: {
        title: '人工客服'
      }
    },
    {
      path: '/attendanceRule',
      name: 'attendanceRule',
      component: resolve => require(['@/components/attendanceRule'], resolve),
      meta: {
        title: '签到规则'
      }
    },
    {
      path: '/paymentAgreement',
      name: 'paymentAgreement',
      component: resolve => require(['@/view/agreement/paymentAgreement'], resolve),
      meta: {
        title: '提现协议'
      }
    },
    {
      path: '/commonProblem',
      name: 'commonProblem',
      component: resolve => require(['@/view/agreement/commonProblem'], resolve),
      meta: {
        title: '活动说明'
      }
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: resolve => require(['@/view/agreement/privacyPolicy'], resolve),
      meta: {
        title: '隐私政策'
      }
    },
    {
      path: '/redPackActivityDescription',
      name: 'redPackActivityDescription',
      component: resolve => require(['@/view/agreement/redPackActivityDescription'], resolve),
      meta: {
        title: '活动说明'
      }
    },
    {
      path: '/myInvitation',
      name: 'myInvitation',
      component: resolve => require(['@/view/myInvitation'], resolve),
      meta: {
        title: '我的邀请'
      }
    },
    {
      path: '/joinFamilyHomeGroup',
      name: 'joinFamilyHomeGroup',
      component: resolve => require(['@/components/joinFamilyHomeGroup'], resolve),
      meta: {
        title: '邀请加入'
      }
    },
    {
      path: '/invitation',
      name: 'invitation',
      component: resolve => require(['@/view/invitation/invitation'], resolve),
      meta: {
        title: '邀请加入'
      }
    },
    {
      path: '/copyJoin', //gtw
      name: 'copyJoin',
      component: resolve => require(['@/view/invitation/copyJoin'], resolve),
      meta: {
        title: '邀请加入'
      }
    },
    {
      path: '/inviteForHelp',
      name: 'inviteForHelp',
      component: resolve => require(['@/components/inviteForHelp'], resolve),
      meta: {
        title: '邀请加入'
      }
    },
    {
      path: '/serviceAgreement',
      name: 'serviceAgreement',
      component: resolve => require(['@/view/agreement/serviceAgreement'], resolve),
      meta: {
        title: '服务协议'
      }
    },
    {
      path: '/inviteHelpRule',
      name: 'inviteHelpRule',
      component: resolve => require(['@/view/agreement/inviteHelpRule'], resolve),
      meta: {
        title: '活动说明'
      }
    },
    {
      path: '/sportsRedEnvelope',
      name: 'sportsRedEnvelope',
      component: resolve => require(['@/view/miniProgram/sportsRedEnvelope'], resolve),
      meta: {
        title: '运动红包'
      }
    },
    {
      path: '/historyDetail',
      name: 'historyDetail',
      component: resolve => require(['@/view/miniProgram/historyDetail'], resolve),
      meta: {
        title: '历史详情'
      }
    },
    {
      path: '/longMarchLine',
      name: 'longMarchLine',
      component: resolve => require(['@/view/miniProgram/longMarchLine'], resolve),
      meta: {
        title: '想动长征路'
      }
    },
    {
      path: '/articleOne',
      name: 'articleOne',
      component: resolve => require(['@/view/miniProgram/articleOne'], resolve),
      meta: {
        title: '运动小百科'
      }
    },
    {
      path: '/articleTwo',
      name: 'articleTwo',
      component: resolve => require(['@/view/miniProgram/articleTwo'], resolve),
      meta: {
        title: '运动小百科'
      }
    },
    {
      path: '/articleThree',
      name: 'articleThree',
      component: resolve => require(['@/view/miniProgram/articleThree'], resolve),
      meta: {
        title: '运动小百科'
      }
    },
    {
      path: '/articleFour',
      name: 'articleFour',
      component: resolve => require(['@/view/miniProgram/articleFour'], resolve),
      meta: {
        title: '运动小百科'
      }
    },
    {
      path: '/springFestivalActivity',
      name: 'springFestivalActivity',
      component: resolve => require(['@/view/activityView/springFestivalActivity'], resolve),
      meta: {
        title: '春节红包'
      }
    },
    {
      path: '/signActivity',
      name: 'signActivity',
      component: resolve => require(['@/view/activityView/signActivity'], resolve),
      meta: {
        title: '全能智能体育赛事'
      }
    },
    {
      path: '/signActivityRule',
      name: 'signActivityRule',
      component: resolve => require(['@/view/agreement/signActivityRule'], resolve),
      meta: {
        title: '赛事规则'
      }
    },
    {
      path: '/springActivityRule',
      name: 'springActivityRule',
      component: resolve => require(['@/view/agreement/springActivityRule'], resolve),
      meta: {
        title: '活动规则'
      }
    },
    {
      path: '/myReportCard',
      name: 'myReportCard',
      component: resolve => require(['@/view/coolMatch/myReportCard'], resolve),
      meta: {
        title: '我的成绩单'
      }
    },
    {
      path: '/reportCardDescible',
      name: 'reportCardDescible',
      component: resolve => require(['@/view/coolMatch/reportCardDescible'], resolve),
      meta: {
        title: '详情'
      }
    },
    {
      path: '/trainingRanking',
      name: 'trainingRanking',
      component: resolve => require(['@/view/coolMatch/trainingRanking'], resolve),
      meta: {
        title: '跳绳训练排行榜'
      }
    },
    {
      path: '/marathonSchoolReport',
      name: 'marathonSchoolReport',
      component: resolve => require(['@/view/marathonEvent/marathonSchoolReport'], resolve),
      meta: {
        title: '我的成绩单'
      }
    },
    {
      path: '/marathonSchoolreportDescible',
      name: 'marathonSchoolreportDescible',
      component: resolve => require(['@/view/marathonEvent/marathonSchoolreportDescible'], resolve),
      meta: {
        title: '成绩单'
      }
    },
    {
      path: '/marathonRankingOne',
      name: 'marathonRankingOne',
      component: resolve => require(['@/view/marathonEvent/marathonRankingOne'], resolve),
      meta: {
        title: '排行榜'
      }
    },
    {
      path: '/marathonRankingTwo',
      name: 'marathonRankingTwo',
      component: resolve => require(['@/view/marathonEvent/marathonRankingTwo'], resolve),
      meta: {
        title: '排行榜'
      }
    },
    {
      path: '/signIn', //gtw
      name: 'signIn',
      component: resolve => require(['@/view/signIn'], resolve),
      meta: {
        title: '签到任务'
      }
    },
    {
      path: '/LevelPrivileges', //gtw
      name: 'LevelPrivileges',
      component: resolve => require(['@/view/signIn/LevelPrivileges'], resolve),
      meta: {
        title: '等级特权'
      }
    },
    {
      path: '/rewardList', //gtw
      name: 'rewardList',
      component: resolve => require(['@/view/signIn/rewardList'], resolve),
      meta: {
        title: '奖励明细'
      }
    },
    {
      path: '/energyValueRule',
      name: 'energyValueRule',
      component: resolve => require(['@/view/agreement/energyValueRule'], resolve),
      meta: {
        title: '活力值说明'
      }
    },
    {
      path: '/myEnergyValue',
      name: 'myEnergyValue',
      component: resolve => require(['@/view/mine/myEnergyValue'], resolve),
      meta: {
        title: '我的活力值'
      }
    },
    {
      path: '/selectCountry',
      name: 'selectCountry',
      component: resolve => require(['@/view/selectCountry'], resolve),
      meta: {
        title: '选择国家和地区'
      }
    },
    {
      path: '/inviteFriend',
      name: 'inviteFriend',
      component: resolve => require(['@/view/invitation/inviteFriend'], resolve),
      meta: {
        title: '邀请加入'
      }
    },
    {
      path: '/inviteRegister',
      name: 'inviteRegister',
      component: resolve => require(['@/view/invitation/inviteRegister'], resolve),
      meta: {
        title: '注册想动账号'
      }
    },
    {
      path: '/activityNews',
      name: 'activityNews',
      component: resolve => require(['@/view/activityView/activityNews'], resolve),
      meta: {
        title: '新闻详情'
      }
    },
    {
      path: '/downLoadNative',
      name: 'downLoadNative',
      component: resolve => require(['@/components/goNativePath'], resolve),
      meta: {
        title: '下载'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.title === '邀请监督') {
    let inviteCode = Common.getUrlKey('inviteCode') || storage.get('inviteCode') || '';
    if (browser.versions.weixin) {
      wxShare(window.location.origin + '/#/register?inviteCode=' + inviteCode)
    }
  }
  next()
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js